import React, { useRef, useEffect, useState, useCallback } from 'react';
import styles from './index.module.scss';

const CONFIG = {
  imageUpload: {
    contents: (
      <path
        d="M13.7812 26.2891V14.3087C13.7812 13.3284 14.6104 12.5338 15.6333 12.5338H26.543M13.7812 26.2891L20.8623 19.0789C21.0413 18.8966 21.3422 18.8923 21.5269 19.0693L25.4921 22.8693C25.6729 23.0426 25.9661 23.0426 26.1469 22.8693L27.82 21.2659C27.9957 21.0975 28.2788 21.0921 28.4615 21.2536L34.1537 26.2891M13.7812 26.2891V26.7328C13.7812 27.713 14.6104 28.5077 15.6333 28.5077H32.3017C33.3245 28.5077 34.1537 27.713 34.1537 26.7328V26.2891M34.1537 26.2891V20M30.9559 12.534L34.1391 12.534M34.1391 12.534L37.3223 12.534M34.1391 12.534V9.12891M34.1391 12.534L34.1537 15.7461"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    viewBox: '11 7 29 23',
    fill: 'none',
  },
  close: {
    contents: (
      <path
        d="M6 6L12 12M18 18L12 12M12 12L18 6M12 12L6 18"
        stroke="#DD391D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'none',
  },
  photo: {
    contents: (
      <>
        <rect x="10.666" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="8" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="5.33398" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="5.33398" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="8" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="10.666" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="2.66602" y="10.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="2.66602" y="13.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="2.66602" y="16" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="2.66602" y="18.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="2.66602" y="21.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="13.334" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="16" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="18.666" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="18.666" y="5.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="21.334" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="21.334" y="5.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="24" y="8" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="24" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="21.334" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="16" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="18.666" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="13.334" y="24" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="13.334" y="20" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="16" y="17.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="16" y="14.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="21.334" y="12" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="13.334" y="12" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="10.666" y="12" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="8" y="14.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="8" y="17.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="10.666" y="20" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="26.666" y="10.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="26.666" y="13.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="26.666" y="16" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="26.666" y="18.6665" width="2.66667" height="2.66667" fill="#FFFF00"/>
        <rect x="26.666" y="21.3335" width="2.66667" height="2.66667" fill="#FFFF00"/>
      </>
    ),
    viewBox: '0 0 32 32',
    fill: 'none',
    width: 32,
    height: 32,
  },
  cake: {
    contents: (
      <>
        <rect x="2.66602" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 2.66602 10.6665)" fill="#FF00FF"/>
        <rect y="16" width="2.66667" height="2.66667" transform="rotate(-90 0 16)" fill="#FF00FF"/>
        <rect y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 0 13.3335)" fill="#FF00FF"/>
        <rect y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 0 18.6665)" fill="#FF00FF"/>
        <rect y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 0 21.3335)" fill="#FF00FF"/>
        <rect x="21.334" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 21.334 21.3335)" fill="#FF00FF"/>
        <rect x="5.33398" y="8" width="2.66667" height="2.66667" transform="rotate(-90 5.33398 8)" fill="#FF00FF"/>
        <rect x="5.33398" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 5.33398 10.6665)" fill="#FF00FF"/>
        <rect x="5.33398" y="2.6665" width="2.66667" height="2.66667" transform="rotate(-90 5.33398 2.6665)" fill="#FF00FF"/>
        <rect x="8" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 8 10.6665)" fill="#FF00FF"/>
        <rect x="10.666" y="8" width="2.66667" height="2.66667" transform="rotate(-90 10.666 8)" fill="#FF00FF"/>
        <rect x="10.666" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 10.666 10.6665)" fill="#FF00FF"/>
        <rect x="10.666" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 10.666 13.3335)" fill="#FF00FF"/>
        <rect x="10.666" y="2.6665" width="2.66667" height="2.66667" transform="rotate(-90 10.666 2.6665)" fill="#FF00FF"/>
        <rect x="13.334" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 13.334 10.6665)" fill="#FF00FF"/>
        <rect y="24" width="2.66667" height="2.66667" transform="rotate(-90 0 24)" fill="#FF00FF"/>
        <rect x="5.33398" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 5.33398 26.6665)" fill="#FF00FF"/>
        <rect x="2.66602" y="24" width="2.66667" height="2.66667" transform="rotate(-90 2.66602 24)" fill="#FF00FF"/>
        <rect x="8" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 8 26.6665)" fill="#FF00FF"/>
        <rect x="10.666" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 10.666 26.6665)" fill="#FF00FF"/>
        <rect x="8" y="18.5957" width="2.66667" height="2.66667" transform="rotate(-90 8 18.5957)" fill="#FF00FF"/>
        <rect x="10.666" y="18.5957" width="2.66667" height="2.66667" transform="rotate(-90 10.666 18.5957)" fill="#FF00FF"/>
        <rect x="13.334" y="18.5957" width="2.66667" height="2.66667" transform="rotate(-90 13.334 18.5957)" fill="#FF00FF"/>
        <rect x="5.33398" y="18.5957" width="2.66667" height="2.66667" transform="rotate(-90 5.33398 18.5957)" fill="#FF00FF"/>
        <rect x="2.66602" y="15.9287" width="2.66667" height="2.66667" transform="rotate(-90 2.66602 15.9287)" fill="#FF00FF"/>
        <rect x="16" y="18.5957" width="2.66667" height="2.66667" transform="rotate(-90 16 18.5957)" fill="#FF00FF"/>
        <rect x="18.666" y="15.9287" width="2.66667" height="2.66667" transform="rotate(-90 18.666 15.9287)" fill="#FF00FF"/>
        <rect x="13.334" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 13.334 26.6665)" fill="#FF00FF"/>
        <rect x="16" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 16 26.6665)" fill="#FF00FF"/>
        <rect x="18.666" y="24" width="2.66667" height="2.66667" transform="rotate(-90 18.666 24)" fill="#FF00FF"/>
        <rect x="16" y="2.6665" width="2.66667" height="2.66667" transform="rotate(-90 16 2.6665)" fill="#FF00FF"/>
        <rect x="21.334" y="24" width="2.66667" height="2.66667" transform="rotate(-90 21.334 24)" fill="#FF00FF"/>
        <rect x="16" y="8" width="2.66667" height="2.66667" transform="rotate(-90 16 8)" fill="#FF00FF"/>
        <rect x="16" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 16 10.6665)" fill="#FF00FF"/>
        <rect x="18.666" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 18.666 10.6665)" fill="#FF00FF"/>
        <rect x="21.334" y="16" width="2.66667" height="2.66667" transform="rotate(-90 21.334 16)" fill="#FF00FF"/>
        <rect x="21.334" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 21.334 13.3335)" fill="#FF00FF"/>
        <rect x="21.334" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 21.334 18.6665)" fill="#FF00FF"/>
      </>
    ),
    viewBox: '0 0 24 27',
    fill: 'none',
    width: 24,
    height: 27,
  },
  username: {
    contents: (
      <>
        <rect x="16" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 16 26.6665)" fill="#8A2BE2"/>
        <rect x="18.667" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 18.667 26.6665)" fill="#8A2BE2"/>
        <rect x="13.333" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 13.333 26.6665)" fill="#8A2BE2"/>
        <rect x="10.667" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-90 10.667 26.6665)" fill="#8A2BE2"/>
        <rect x="8" y="24" width="2.66667" height="2.66667" transform="rotate(-90 8 24)" fill="#8A2BE2"/>
        <rect x="5.33301" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 5.33301 21.3335)" fill="#8A2BE2"/>
        <rect x="5.33301" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 5.33301 18.6665)" fill="#8A2BE2"/>
        <rect x="5.33301" y="16" width="2.66667" height="2.66667" transform="rotate(-90 5.33301 16)" fill="#8A2BE2"/>
        <rect x="5.33301" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 5.33301 13.3335)" fill="#8A2BE2"/>
        <rect x="10.667" y="8" width="2.66667" height="2.66667" transform="rotate(-90 10.667 8)" fill="#8A2BE2"/>
        <rect x="8" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 8 10.6665)" fill="#8A2BE2"/>
        <rect x="13.333" y="8" width="2.66667" height="2.66667" transform="rotate(-90 13.333 8)" fill="#8A2BE2"/>
        <rect x="16" y="8" width="2.66667" height="2.66667" transform="rotate(-90 16 8)" fill="#8A2BE2"/>
        <rect x="18.667" y="8" width="2.66667" height="2.66667" transform="rotate(-90 18.667 8)" fill="#8A2BE2"/>
        <rect x="21.333" y="8" width="2.66667" height="2.66667" transform="rotate(-90 21.333 8)" fill="#8A2BE2"/>
        <rect x="24" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-90 24 10.6665)" fill="#8A2BE2"/>
        <path d="M24 13.3335L24 10.6668L26.6667 10.6668L26.6667 13.3335L24 13.3335Z" fill="#8A2BE2"/>
        <rect x="24" y="16" width="2.66667" height="2.66667" transform="rotate(-90 24 16)" fill="#8A2BE2"/>
        <rect x="24" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 24 18.6665)" fill="#8A2BE2"/>
        <rect x="24" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 24 21.3335)" fill="#8A2BE2"/>
        <rect x="21.333" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 21.333 21.3335)" fill="#8A2BE2"/>
        <rect x="18.667" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 18.667 18.6665)" fill="#8A2BE2"/>
        <rect x="18.667" y="16" width="2.66667" height="2.66667" transform="rotate(-90 18.667 16)" fill="#8A2BE2"/>
        <rect x="18.667" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 18.667 13.3335)" fill="#8A2BE2"/>
        <rect x="16" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 16 13.3335)" fill="#8A2BE2"/>
        <rect x="13.333" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-90 13.333 13.3335)" fill="#8A2BE2"/>
        <rect x="10.667" y="16" width="2.66667" height="2.66667" transform="rotate(-90 10.667 16)" fill="#8A2BE2"/>
        <rect x="10.667" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-90 10.667 18.6665)" fill="#8A2BE2"/>
        <rect x="13.333" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 13.333 21.3335)" fill="#8A2BE2"/>
        <rect x="16" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-90 16 21.3335)" fill="#8A2BE2"/>
      </>
    ),
    viewBox: '0 0 32 32',
    fill: 'none',
    width: 32,
    height: 32,
  },
  party: {
    contents: (
      <>
        <rect x="9.33301" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 26.6665)" fill="#00BFFF"/>
        <rect x="9.33301" y="16" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 16)" fill="#00BFFF"/>
        <rect x="9.33301" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 21.3335)" fill="#00BFFF"/>
        <rect x="12" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 12 21.3335)" fill="#00BFFF"/>
        <rect x="12" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-180 12 18.6665)" fill="#00BFFF"/>
        <rect x="12" y="16" width="2.66667" height="2.66667" transform="rotate(-180 12 16)" fill="#00BFFF"/>
        <rect x="12" y="24" width="2.66667" height="2.66667" transform="rotate(-180 12 24)" fill="#00BFFF"/>
        <rect x="9.33301" y="24" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 24)" fill="#00BFFF"/>
        <rect x="20" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 20 26.6665)" fill="#00BFFF"/>
        <rect x="6.66699" y="24" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 24)" fill="#00BFFF"/>
        <rect x="17.333" y="24" width="2.66667" height="2.66667" transform="rotate(-180 17.333 24)" fill="#00BFFF"/>
        <rect x="6.66699" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 21.3335)" fill="#00BFFF"/>
        <rect x="17.333" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 17.333 21.3335)" fill="#00BFFF"/>
        <rect x="6.66699" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 18.6665)" fill="#00BFFF"/>
        <rect x="17.333" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-180 17.333 18.6665)" fill="#00BFFF"/>
        <rect x="20" y="16" width="2.66667" height="2.66667" transform="rotate(-180 20 16)" fill="#00BFFF"/>
        <rect x="20" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 20 21.3335)" fill="#00BFFF"/>
        <rect x="22.667" y="24" width="2.66667" height="2.66667" transform="rotate(-180 22.667 24)" fill="#00BFFF"/>
        <rect x="20" y="24" width="2.66667" height="2.66667" transform="rotate(-180 20 24)" fill="#00BFFF"/>
        <rect x="22.667" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 22.667 21.3335)" fill="#00BFFF"/>
        <rect x="22.667" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-180 22.667 18.6665)" fill="#00BFFF"/>
        <rect x="22.667" y="16" width="2.66667" height="2.66667" transform="rotate(-180 22.667 16)" fill="#00BFFF"/>
        <rect x="6.66699" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 13.3335)" fill="#00BFFF"/>
        <rect x="17.333" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-180 17.333 13.3335)" fill="#00BFFF"/>
        <rect x="6.66699" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 10.6665)" fill="#00BFFF"/>
        <rect x="17.333" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-180 17.333 10.6665)" fill="#00BFFF"/>
        <rect x="9.33301" y="8" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 8)" fill="#00BFFF"/>
        <rect x="20" y="8" width="2.66667" height="2.66667" transform="rotate(-180 20 8)" fill="#00BFFF"/>
        <rect x="12" y="8" width="2.66667" height="2.66667" transform="rotate(-180 12 8)" fill="#00BFFF"/>
        <rect x="22.667" y="8" width="2.66667" height="2.66667" transform="rotate(-180 22.667 8)" fill="#00BFFF"/>
        <rect x="14.667" y="8" width="2.66667" height="2.66667" transform="rotate(-180 14.667 8)" fill="#00BFFF"/>
        <rect x="25.333" y="8" width="2.66667" height="2.66667" transform="rotate(-180 25.333 8)" fill="#00BFFF"/>
        <rect x="28" y="10.6665" width="2.66667" height="2.66667" transform="rotate(-180 28 10.6665)" fill="#00BFFF"/>
        <rect x="28" y="13.3335" width="2.66667" height="2.66667" transform="rotate(-180 28 13.3335)" fill="#00BFFF"/>
        <rect x="28" y="16" width="2.66667" height="2.66667" transform="rotate(-180 28 16)" fill="#00BFFF"/>
        <rect x="28" y="18.6665" width="2.66667" height="2.66667" transform="rotate(-180 28 18.6665)" fill="#00BFFF"/>
        <rect x="28" y="21.3335" width="2.66667" height="2.66667" transform="rotate(-180 28 21.3335)" fill="#00BFFF"/>
        <rect x="28" y="24" width="2.66667" height="2.66667" transform="rotate(-180 28 24)" fill="#00BFFF"/>
        <rect x="14.667" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 14.667 26.6665)" fill="#00BFFF"/>
        <rect x="25.333" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 25.333 26.6665)" fill="#00BFFF"/>
        <rect x="12" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 12 26.6665)" fill="#00BFFF"/>
        <rect x="22.667" y="26.6665" width="2.66667" height="2.66667" transform="rotate(-180 22.667 26.6665)" fill="#00BFFF"/>
        <rect x="6.66699" y="16" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 16)" fill="#00BFFF"/>
        <rect x="17.333" y="16" width="2.66667" height="2.66667" transform="rotate(-180 17.333 16)" fill="#00BFFF"/>
      </>
    ),
    viewBox: '0 0 32 32',
    fill: 'none',
  },
  check: {
    contents: (
      <>
        <rect x="3.33301" y="11.6667" width="1.66667" height="1.66667" transform="rotate(-90 3.33301 11.6667)" fill="#00FF00"/>
        <rect x="6.66699" y="15" width="1.66667" height="1.66667" transform="rotate(-90 6.66699 15)" fill="#00FF00"/>
        <rect x="10" y="11.6667" width="1.66667" height="1.66667" transform="rotate(-90 10 11.6667)" fill="#00FF00"/>
        <rect x="13.333" y="8.33325" width="1.66667" height="1.66667" transform="rotate(-90 13.333 8.33325)" fill="#00FF00"/>
        <rect x="5" y="13.3333" width="1.66667" height="1.66667" transform="rotate(-90 5 13.3333)" fill="#00FF00"/>
        <rect x="8.33301" y="13.3333" width="1.66667" height="1.66667" transform="rotate(-90 8.33301 13.3333)" fill="#00FF00"/>
        <rect x="11.667" y="10" width="1.66667" height="1.66667" transform="rotate(-90 11.667 10)" fill="#00FF00"/>
        <rect x="15" y="6.66675" width="1.66667" height="1.66667" transform="rotate(-90 15 6.66675)" fill="#00FF00"/>
      </>
    ),
    viewBox: '0 0 20 20',
    fill: 'none',
    width: 20,
    height: 20,
  },
  closeSmall: {
    contents: (
      <>
        <rect x="14.167" y="5.78882" width="1.66667" height="1.66667" transform="rotate(-90 14.167 5.78882)" fill="#FF0000"/>
        <rect x="7.5" y="12.4556" width="1.66667" height="1.66667" transform="rotate(-90 7.5 12.4556)" fill="#FF0000"/>
        <rect x="12.5" y="7.45557" width="1.66667" height="1.66667" transform="rotate(-90 12.5 7.45557)" fill="#FF0000"/>
        <rect x="5.83301" y="14.1223" width="1.66667" height="1.66667" transform="rotate(-90 5.83301 14.1223)" fill="#FF0000"/>
        <rect x="10.833" y="9.12231" width="1.66667" height="1.66667" transform="rotate(-90 10.833 9.12231)" fill="#FF0000"/>
        <rect x="4.16699" y="15.7888" width="1.66667" height="1.66667" transform="rotate(-90 4.16699 15.7888)" fill="#FF0000"/>
        <rect x="9.16699" y="10.7888" width="1.66667" height="1.66667" transform="rotate(-90 9.16699 10.7888)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 5.83301 5.78882)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 12.5 12.4556)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 7.5 7.45557)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 14.167 14.1223)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 9.16699 9.12231)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 15.833 15.7888)" fill="#FF0000"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 10.833 10.7888)" fill="#FF0000"/>
      </>
    ),
    viewBox: '0 0 20 20',
    fill: 'none',
    width: 20,
    height: 20,
  },
  generate: {
    contents: (
      <>
        <rect x="9.16699" y="2.5" width="1.66667" height="1.66667"/>
        <rect x="10.833" y="17.5" width="1.66667" height="1.66667" transform="rotate(-180 10.833 17.5)"/>
        <rect x="7.5" y="5.8335" width="1.66667" height="1.66667"/>
        <rect x="7.5" y="4.1665" width="1.66667" height="1.66667"/>
        <rect x="12.5" y="14.1665" width="1.66667" height="1.66667" transform="rotate(-180 12.5 14.1665)"/>
        <rect x="12.5" y="15.8335" width="1.66667" height="1.66667" transform="rotate(-180 12.5 15.8335)"/>
        <rect x="5.83301" y="7.5" width="1.66667" height="1.66667"/>
        <rect x="4.16699" y="7.5" width="1.66667" height="1.66667"/>
        <rect x="14.167" y="12.5" width="1.66667" height="1.66667" transform="rotate(-180 14.167 12.5)"/>
        <rect x="15.833" y="12.5" width="1.66667" height="1.66667" transform="rotate(-180 15.833 12.5)"/>
        <rect x="2.5" y="9.1665" width="1.66667" height="1.66667"/>
        <rect x="10.833" y="5.8335" width="1.66667" height="1.66667"/>
        <rect x="10.833" y="4.1665" width="1.66667" height="1.66667"/>
        <rect x="9.16699" y="14.1665" width="1.66667" height="1.66667" transform="rotate(-180 9.16699 14.1665)"/>
        <rect x="9.16699" y="15.8335" width="1.66667" height="1.66667" transform="rotate(-180 9.16699 15.8335)"/>
        <rect x="12.5" y="7.5" width="1.66667" height="1.66667"/>
        <rect x="14.167" y="7.5" width="1.66667" height="1.66667"/>
        <rect x="7.5" y="12.5" width="1.66667" height="1.66667" transform="rotate(-180 7.5 12.5)"/>
        <rect x="5.83301" y="12.5" width="1.66667" height="1.66667" transform="rotate(-180 5.83301 12.5)"/>
        <rect x="15.833" y="9.1665" width="1.66667" height="1.66667"/>
      </>
    ),
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    width: 20,
    height: 20,
  },
  upload: {
    contents: (
      <>
        <rect x="16" y="12" width="4" height="4" fill="black"/>
        <rect x="12" y="12" width="4" height="4" fill="black"/>
        <rect x="8" y="12" width="4" height="4" fill="black"/>
        <rect x="8" y="36" width="4" height="4" fill="black"/>
        <rect x="12" y="36" width="4" height="4" fill="black"/>
        <rect x="16" y="36" width="4" height="4" fill="black"/>
        <rect x="4" y="16" width="4" height="4" fill="black"/>
        <rect x="4" y="20" width="4" height="4" fill="black"/>
        <rect x="4" y="24" width="4" height="4" fill="black"/>
        <rect x="4" y="28" width="4" height="4" fill="black"/>
        <rect x="4" y="32" width="4" height="4" fill="black"/>
        <rect x="20" y="12" width="4" height="4" fill="black"/>
        <rect x="24" y="12" width="4" height="4" fill="black"/>
        <rect x="28" y="12" width="4" height="4" fill="black"/>
        <rect x="28" y="8" width="4" height="4" fill="black"/>
        <rect x="32" y="12" width="4" height="4" fill="black"/>
        <rect x="32" y="8" width="4" height="4" fill="black"/>
        <rect x="36" y="12" width="4" height="4" fill="black"/>
        <rect x="24" y="36" width="4" height="4" fill="black"/>
        <rect x="28" y="36" width="4" height="4" fill="black"/>
        <rect x="20" y="36" width="4" height="4" fill="black"/>
        <rect x="20" y="30" width="4" height="4" fill="black"/>
        <rect x="24" y="26" width="4" height="4" fill="black"/>
        <rect x="24" y="22" width="4" height="4" fill="black"/>
        <rect x="32" y="18" width="4" height="4" fill="black"/>
        <rect x="20" y="18" width="4" height="4" fill="black"/>
        <rect x="16" y="18" width="4" height="4" fill="black"/>
        <rect x="12" y="22" width="4" height="4" fill="black"/>
        <rect x="12" y="26" width="4" height="4" fill="black"/>
        <rect x="16" y="30" width="4" height="4" fill="black"/>
        <rect x="40" y="16" width="4" height="4" fill="black"/>
        <rect x="40" y="20" width="4" height="4" fill="black"/>
        <rect x="40" y="24" width="4" height="4" fill="black"/>
        <rect x="40" y="35.8936" width="4" height="4" fill="black"/>
        <rect x="40" y="39.8936" width="4" height="4" fill="black"/>
        <rect x="44" y="35.8936" width="4" height="4" fill="black"/>
        <rect x="36" y="35.8936" width="4" height="4" fill="black"/>
        <rect x="40" y="31.8936" width="4" height="4" fill="black"/>
      </>
    ),
    viewBox: '0 0 48 48',
    fill: 'none',
    width: 48,
    height: 48,
  },
  inviteCode: {
    contents: (
      <>
        <rect x="20" y="14.5952" width="2.66667" height="2.66667" transform="rotate(-90 20 14.5952)" fill="#FF1493"/>
        <rect x="22.666" y="11.9292" width="2.66667" height="2.66667" transform="rotate(-90 22.666 11.9292)" fill="#FF1493"/>
        <rect x="17.334" y="17.2622" width="2.66667" height="2.66667" transform="rotate(-90 17.334 17.2622)" fill="#FF1493"/>
        <rect x="14.666" y="19.9292" width="2.66667" height="2.66667" transform="rotate(-90 14.666 19.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 6.66602 11.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 6.66602 14.5957)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 6.66602 17.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 6.66602 19.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 6.66602 22.5957)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 9.33398 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 12 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 14.666 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 17.334 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 20 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 22.666 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 25.334 25.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 28 22.5957)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 28 19.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 28 17.2622)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 28 14.5957)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 28 11.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 22.666 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 25.334 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 20 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 17.334 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 14.666 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 12 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 9.33398 9.26221)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 12 14.5952)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 9.33398 11.9292)" fill="#FF1493"/>
        <rect width="2.66667" height="2.66667" transform="matrix(-4.80825e-07 -1 -1 4.80825e-07 14.666 17.2622)" fill="#FF1493"/>
      </>
    ),
    viewBox: '0 0 32 32',
    fill: 'none',
    width: 32,
    height: 32,
  },
  notification: {
    contents: (
      <>
        <rect x="22.667" y="28" width="2.66667" height="2.66667" transform="rotate(-180 22.667 28)" fill="#00FF00"/>
        <rect x="25.333" y="25.3335" width="2.66667" height="2.66667" transform="rotate(-180 25.333 25.3335)" fill="#00FF00"/>
        <rect x="14.667" y="28" width="2.66667" height="2.66667" transform="rotate(-180 14.667 28)" fill="#00FF00"/>
        <rect x="17.333" y="22.6665" width="2.66667" height="2.66667" transform="rotate(-180 17.333 22.6665)" fill="#00FF00"/>
        <rect x="17.333" y="14.6665" width="2.66667" height="2.66667" transform="rotate(-180 17.333 14.6665)" fill="#00FF00"/>
        <rect x="17.333" y="17.3335" width="2.66667" height="2.66667" transform="rotate(-180 17.333 17.3335)" fill="#00FF00"/>
        <rect x="17.333" y="12" width="2.66667" height="2.66667" transform="rotate(-180 17.333 12)" fill="#00FF00"/>
        <rect x="20" y="28" width="2.66667" height="2.66667" transform="rotate(-180 20 28)" fill="#00FF00"/>
        <rect x="17.333" y="28" width="2.66667" height="2.66667" transform="rotate(-180 17.333 28)" fill="#00FF00"/>
        <rect x="12" y="28" width="2.66667" height="2.66667" transform="rotate(-180 12 28)" fill="#00FF00"/>
        <rect x="9.33301" y="25.3335" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 25.3335)" fill="#00FF00"/>
        <rect x="6.66699" y="22.6665" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 22.6665)" fill="#00FF00"/>
        <rect x="6.66699" y="20" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 20)" fill="#00FF00"/>
        <rect x="6.66699" y="14.6665" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 14.6665)" fill="#00FF00"/>
        <rect x="6.66699" y="17.3335" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 17.3335)" fill="#00FF00"/>
        <rect x="28" y="17.3335" width="2.66667" height="2.66667" transform="rotate(-180 28 17.3335)" fill="#00FF00"/>
        <rect x="6.66699" y="12" width="2.66667" height="2.66667" transform="rotate(-180 6.66699 12)" fill="#00FF00"/>
        <rect x="9.33301" y="9.3335" width="2.66667" height="2.66667" transform="rotate(-180 9.33301 9.3335)" fill="#00FF00"/>
        <rect x="12" y="6.6665" width="2.66667" height="2.66667" transform="rotate(-180 12 6.6665)" fill="#00FF00"/>
        <rect x="14.667" y="6.6665" width="2.66667" height="2.66667" transform="rotate(-180 14.667 6.6665)" fill="#00FF00"/>
        <rect x="20" y="6.6665" width="2.66667" height="2.66667" transform="rotate(-180 20 6.6665)" fill="#00FF00"/>
        <rect x="17.333" y="6.6665" width="2.66667" height="2.66667" transform="rotate(-180 17.333 6.6665)" fill="#00FF00"/>
        <rect x="22.667" y="6.6665" width="2.66667" height="2.66667" transform="rotate(-180 22.667 6.6665)" fill="#00FF00"/>
        <rect x="25.333" y="9.3335" width="2.66667" height="2.66667" transform="rotate(-180 25.333 9.3335)" fill="#00FF00"/>
        <rect x="28" y="12" width="2.66667" height="2.66667" transform="rotate(-180 28 12)" fill="#00FF00"/>
        <rect x="28" y="14.6665" width="2.66667" height="2.66667" transform="rotate(-180 28 14.6665)" fill="#00FF00"/>
        <rect x="28" y="20" width="2.66667" height="2.66667" transform="rotate(-180 28 20)" fill="#00FF00"/>
        <rect x="28" y="22.6665" width="2.66667" height="2.66667" transform="rotate(-180 28 22.6665)" fill="#00FF00"/>
      </>
    ),
    viewBox: '0 0 32 32',
    fill: 'none',
    width: 32,
    height: 32,
  },
  circleArrow: {
    contents: (
      <>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 14.1665 2.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 12.5 17.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 10.8335 17.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 9.1665 17.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 7.5 15.8334)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 17.5 5.83337)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 17.5 4.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 15.8335 4.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 19.1665 7.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 19.1665 9.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 9.1665 4.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 7.5 4.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 7.5 5.83337)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 7.5 7.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 10.8335 2.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 12.5 2.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 14.1665 15.8334)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 15.8335 15.8334)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 15.8335 14.1666)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 17.5 12.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 9.1665 9.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 10.8335 7.5)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 7.5 10.8334)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 5.8335 9.16663)" fill="white"/>
        <rect width="1.66667" height="1.66667" transform="matrix(-1 0 0 1 4.1665 7.5)" fill="white"/>
      </>
    ),
    viewBox: '0 0 20 20',
    fill: 'none',
    width: 20,
    height: 20,
  },
  spiral: {
    contents: (
      <>
        <rect x="2.5" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 2.5 3.33337)" fill="white"/>
        <rect x="2.5" y="5" width="1.66667" height="1.66667" transform="rotate(-90 2.5 5)" fill="white"/>
        <rect x="2.5" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 2.5 6.66663)" fill="white"/>
        <rect x="2.5" y="8.33337" width="1.66667" height="1.66667" transform="rotate(-90 2.5 8.33337)" fill="white"/>
        <rect x="2.5" y="10" width="1.66667" height="1.66667" transform="rotate(-90 2.5 10)" fill="white"/>
        <rect x="2.5" y="11.6666" width="1.66667" height="1.66667" transform="rotate(-90 2.5 11.6666)" fill="white"/>
        <rect x="2.5" y="13.3334" width="1.66667" height="1.66667" transform="rotate(-90 2.5 13.3334)" fill="white"/>
        <rect x="2.5" y="15" width="1.66667" height="1.66667" transform="rotate(-90 2.5 15)" fill="white"/>
        <rect x="2.5" y="16.6666" width="1.66667" height="1.66667" transform="rotate(-90 2.5 16.6666)" fill="white"/>
        <rect x="2.5" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 2.5 18.3334)" fill="white"/>
        <rect x="4.1665" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 4.1665 18.3334)" fill="white"/>
        <rect x="5.8335" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 18.3334)" fill="white"/>
        <rect x="7.5" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 7.5 18.3334)" fill="white"/>
        <rect x="9.1665" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 18.3334)" fill="white"/>
        <rect x="10.8335" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 10.8335 18.3334)" fill="white"/>
        <rect x="12.5" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 12.5 18.3334)" fill="white"/>
        <rect x="14.1665" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 14.1665 18.3334)" fill="white"/>
        <rect x="15.8335" y="18.3334" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 18.3334)" fill="white"/>
        <rect x="15.8335" y="16.6666" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 16.6666)" fill="white"/>
        <rect x="15.8335" y="15" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 15)" fill="white"/>
        <rect x="15.8335" y="13.3334" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 13.3334)" fill="white"/>
        <rect x="15.8335" y="11.6666" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 11.6666)" fill="white"/>
        <rect x="15.8335" y="10" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 10)" fill="white"/>
        <rect x="15.8335" y="8.33337" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 8.33337)" fill="white"/>
        <rect x="15.8335" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 6.66663)" fill="white"/>
        <rect x="14.1665" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 14.1665 6.66663)" fill="white"/>
        <rect x="12.5" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 12.5 6.66663)" fill="white"/>
        <rect x="10.8335" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 10.8335 6.66663)" fill="white"/>
        <rect x="9.1665" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 6.66663)" fill="white"/>
        <rect x="7.5" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 7.5 6.66663)" fill="white"/>
        <rect x="5.8335" y="6.66663" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 6.66663)" fill="white"/>
        <rect x="5.8335" y="8.33337" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 8.33337)" fill="white"/>
        <rect x="5.8335" y="10" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 10)" fill="white"/>
        <rect x="5.8335" y="11.6666" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 11.6666)" fill="white"/>
        <rect x="5.8335" y="13.3334" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 13.3334)" fill="white"/>
        <rect x="5.8335" y="15" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 15)" fill="white"/>
        <rect x="7.5" y="15" width="1.66667" height="1.66667" transform="rotate(-90 7.5 15)" fill="white"/>
        <rect x="9.1665" y="15" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 15)" fill="white"/>
        <rect x="10.8335" y="15" width="1.66667" height="1.66667" transform="rotate(-90 10.8335 15)" fill="white"/>
        <rect x="12.5" y="15" width="1.66667" height="1.66667" transform="rotate(-90 12.5 15)" fill="white"/>
        <rect x="12.5" y="13.3334" width="1.66667" height="1.66667" transform="rotate(-90 12.5 13.3334)" fill="white"/>
        <rect x="12.5" y="11.6666" width="1.66667" height="1.66667" transform="rotate(-90 12.5 11.6666)" fill="white"/>
        <rect x="12.5" y="10" width="1.66667" height="1.66667" transform="rotate(-90 12.5 10)" fill="white"/>
        <rect x="10.8335" y="10" width="1.66667" height="1.66667" transform="rotate(-90 10.8335 10)" fill="white"/>
        <rect x="9.1665" y="10" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 10)" fill="white"/>
        <rect x="9.1665" y="11.6666" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 11.6666)" fill="white"/>
        <rect x="4.1665" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 4.1665 3.33337)" fill="white"/>
        <rect x="5.8335" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 5.8335 3.33337)" fill="white"/>
        <rect x="7.5" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 7.5 3.33337)" fill="white"/>
        <rect x="9.1665" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 9.1665 3.33337)" fill="white"/>
        <rect x="10.8335" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 10.8335 3.33337)" fill="white"/>
        <rect x="12.5" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 12.5 3.33337)" fill="white"/>
        <rect x="14.1665" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 14.1665 3.33337)" fill="white"/>
        <rect x="15.8335" y="3.33337" width="1.66667" height="1.66667" transform="rotate(-90 15.8335 3.33337)" fill="white"/>
      </>
    ),
    viewBox: '0 0 20 20',
    fill: 'none',
    width: 20,
    height: 20,
  },
  arrowUp: {
    contents: (
      <>
        <rect x="15.1666" y="12.8333" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 12.8333)" fill="currentColor"/>
        <rect x="15.1666" y="15.1667" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 15.1667)" fill="currentColor"/>
        <rect x="15.1666" y="17.5" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 17.5)" fill="currentColor"/>
        <rect x="15.1666" y="19.8333" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 19.8333)" fill="currentColor"/>
        <rect x="15.1666" y="22.1667" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 22.1667)" fill="currentColor"/>
        <rect x="19.8334" y="12.8333" width="2.33333" height="2.33333" transform="rotate(-180 19.8334 12.8333)" fill="currentColor"/>
        <rect x="22.1666" y="15.1667" width="2.33333" height="2.33333" transform="rotate(-180 22.1666 15.1667)" fill="currentColor"/>
        <rect x="17.5" y="10.5" width="2.33333" height="2.33333" transform="rotate(-180 17.5 10.5)" fill="currentColor"/>
        <rect x="15.1666" y="8.16669" width="2.33333" height="2.33333" transform="rotate(-180 15.1666 8.16669)" fill="currentColor"/>
        <rect x="12.8334" y="10.5" width="2.33333" height="2.33333" transform="rotate(-180 12.8334 10.5)" fill="currentColor"/>
        <rect x="10.5" y="12.8333" width="2.33333" height="2.33333" transform="rotate(-180 10.5 12.8333)" fill="currentColor"/>
        <rect x="8.16663" y="15.1667" width="2.33333" height="2.33333" transform="rotate(-180 8.16663 15.1667)" fill="currentColor"/>
      </>
    ),
    viewBox: '0 0 28 28',
    fill: 'none',
    width: 28,
    height: 28,
  },
  downloadPixelated: {
    contents: (
      <>
        <rect x="11" y="10" width="2" height="2" fill="currentColor"/>
        <rect x="11" y="8" width="2" height="2" fill="currentColor"/>
        <rect x="11" y="6" width="2" height="2" fill="currentColor"/>
        <rect x="11" y="4" width="2" height="2" fill="currentColor"/>
        <rect x="7" y="10" width="2" height="2" fill="currentColor"/>
        <rect x="9" y="12" width="2" height="2" fill="currentColor"/>
        <rect x="11" y="14" width="2" height="2" fill="currentColor"/>
        <rect x="11" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="13" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="15" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="17" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="17" y="15.9467" width="2" height="2" fill="currentColor"/>
        <rect x="9" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="7" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="5" y="17.9467" width="2" height="2" fill="currentColor"/>
        <rect x="5" y="15.9467" width="2" height="2" fill="currentColor"/>
        <rect x="13" y="12" width="2" height="2" fill="currentColor"/>
        <rect x="15" y="10" width="2" height="2" fill="currentColor"/>
      </>
    ),
    viewBox: '0 0 24 24',
    fill: 'none',
    width: 24,
    height: 24,
  },
};

export function Icon({ className, type, height, width, onClick = () => {} }) {
  const iconRef = useRef(null);
  const hoverColor = CONFIG[type]?.hoverColor;

  const [iconHeight, setIconHeight] = useState(0);

  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  useEffect(() => {
    setIconHeight(height ?? iconRef.current.getBoundingClientRect().width);
  }, [height]);

  const props = {
    viewBox: CONFIG[type]?.viewBox || '0 0 38 38',
    className,
    xmlns: 'http://www.w3.org/2000/svg',
    fill: CONFIG[type]?.fill || null,
    height: height || CONFIG[type]?.height,
    width: width || CONFIG[type]?.width,
  };
  return (
    <div
      className={`${styles.wrapper} ${hoverColor ? styles.hover : ''} `}
      onClick={handleClick}
    >
      {CONFIG[type]?.hoverColor && (
        <div
          className={styles.hoverHighlight}
          style={{
            backgroundColor: hoverColor,
            height: iconHeight + iconHeight * 0.3,
            width: iconHeight + iconHeight * 0.3,
          }}
        />
      )}
      <svg ref={iconRef} {...props}>
        {CONFIG[type].contents}
      </svg>
    </div>
  );
}

export default Icon;
